<div class="status" [class.opened]="isStatusOpen">
  <button type="button" class="btn status-toggle" (click)="statusToggle()">
    <ng-container [ngSwitch]="status">
      <ion-icon
        name="ellipse"
        class="ion-lg"
        [ngClass]="{ 'color-red': isDeviceOnline, 'color-gray': !isDeviceOnline }"
        *ngSwitchCase="false"
      ></ion-icon>
      <ion-icon name="ellipse" class="color-green ion-lg" *ngSwitchCase="true"></ion-icon>
    </ng-container>
  </button>

  <div class="status__info ml-auto">
    <div class="form-group m-0">
      <div class="credential__switch">
        <span class="credential__switch--text">Available</span>
        <div class="credential__switch--inputGrp">
          <input
            type="checkbox"
            name="status"
            id="status"
            class="credential__switch--input"
            (change)="setStatus($event)"
            [checked]="!status"
          />
          <label for="status" class="credential__switch--label"></label>
        </div>
        <span class="credential__switch--text">Busy</span>
      </div>
    </div>
  </div>
</div>
